





























































import { Vue, Component } from 'vue-property-decorator';
import { Toast, Field } from 'vant';
import { isWeiXin } from '@/common/ts/common';
import Uploader from '@/components/Uploader.vue';
import { register } from '../api';
import qs from 'qs';

Vue.use(Toast).use(Field);

@Component({
  components: {
    Uploader,
  },
})
export default class Register extends Vue {
  title = '';
  stuName = '';
  teacherName = '';
  schoolName = '';
  age = '';
  intro = '';
  phone = '';

  created() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.WechatLogin();
    }
    if (window.udid) {
      this.AppLogin();
    }
  }
  checkForm() {
    const mobileReg =
      /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/;
    if (!this.title) {
      Toast('请填写作品名称');
      return false;
    } else if (!this.stuName) {
      Toast('请填写作者姓名');
      return false;
    } else if (!this.teacherName) {
      Toast('请填写指导老师姓名');
      return false;
    } else if (!this.schoolName) {
      Toast('请填写学校名称');
      return false;
    } else if (!this.age) {
      Toast('请填写年龄');
      return false;
    } else if (!this.phone || !/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('请填写正确的手机号');
      return false;
    } else if (!this.intro) {
      Toast('请填写个人简介');
      return false;
    } else {
      return true;
    }
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  async onSubmit() {
    if (!this.checkForm()) {
      return;
    }
    const retImages: any = await (
      this.$refs.uploader as Uploader
    ).uploadToOss();
    const retRegister: any = await register({
      unionid: window.localStorage.getItem('unionid'),
      title: this.title,
      name: this.stuName,
      year: this.age,
      teacher: this.teacherName,
      school: this.schoolName,
      introduction: this.intro,
      cover: retImages.join('|'),
      phone: this.phone,
      udid: window.udid,
      appkey: window.appkey,
    });
    if (retRegister.code === 200) {
      Toast(retRegister.msg);
      this.reset();
    } else {
      Toast(retRegister.msg);
    }
  }
  reset() {
    setTimeout(() => {
      this.$router.go(0);
    }, 1500);
  }
}
